import { UseQueryResult, useQuery } from '@tanstack/react-query';

import {
  Entities_Notification_Count_Response,
  LoginId,
} from '@suntex.fim/api-client';
import { useFramework } from '@suntex.fim/framework';

const FIVE_MINUTES_MS = 300_000;

/**
 * Returns the unread notification count for the given loginId.
 * Stale for 5 minutes; disabled when loginId is absent or 0.
 */
export function useNotificationCount(
  loginId: LoginId,
  options?: { enabled?: boolean },
): UseQueryResult<Entities_Notification_Count_Response> {
  const { api } = useFramework();
  return useQuery({
    queryKey: ['notificationCount', loginId],
    queryFn: () => api.get_Notification_Count({ loginId }),
    enabled: options?.enabled ?? (!!loginId && loginId !== 0),
    staleTime: FIVE_MINUTES_MS,
  });
}
